module.exports = __webpack_public_path__ + "static/media/ButtonsVersions_02.32842669.png";